@if (isAdmin()) {
    <div class="new-tile">
        <button
            type="button"
            class="btn btn-primary"
            [attr.aria-label]="'accessibility.add-new-tile' | translate"
            (click)="addNewTile()"
        >
            <si-icon icon="element-add" />
            <span>{{ 'tileDialog.buttons.addNew' | translate }}</span>
        </button>
    </div>
}
@if (isLoading()) {
    @for (i of skeletonItems; track i) {
        <si-card
            class="mb-6 mr-6 block h-[170px] w-[170px] overflow-hidden opacity-90 max-md:mr-0 max-md:h-[95px] max-md:w-full"
            aria-hidden="true"
        >
            <div
                body
                class="flex h-full animate-pulse flex-col justify-between bg-[var(--si-sys-color-effects-logo)] p-3 max-md:flex-row max-md:items-center max-md:px-5 max-md:py-0"
            >
                <div class="h-4 w-3/5 rounded bg-white/60"></div>
                <div class="size-6 rounded bg-white/60 self-end max-md:self-center"></div>
            </div>
        </si-card>
    }
} @else {
    @for (item of data(); track item.id) {
        <div>
            <app-tile [tile]="item"></app-tile>
        </div>
    }
}
